<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="alert alert-success mb-4 alert-dismissible fade show" role="alert">
                    Trascina i campi dal selettore di destra alle caselle di sinistra corrispondenti ai tuoi dati.
                    Le colonne non mappate non verranno importate nel modello.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="col-md-8">
                <div class="card-custom bg-white mb-4">
                    <div class="card-header border-bottom-light  bg-white">
                        <h5 class="my-2 py-1  fw-600">Mapping the Data Fields</h5>
                    </div>
                    <div class="card-body bg-white">
                        <div class="row">
                            <div class="col-6 pe-0">
                                <div v-for="(column, index) in columns" :key="index"
                                     class="main-mapping-box mb-2 px-3 py-1 d-flex flex-column justify-content-center">
                                    <div class="fw-600 text-sm m-0 mb-1">{{ column.name }}</div>
                                    <div class="text-grey m-0">{{ column.format }}</div>
                                </div>
                            </div>
                            <div class="col-6 ps-0 import-master-fields">
                                <div v-for="(column, index) in columns" :key="index"
                                     class="main-mapping-box px-3 py-1 d-flex align-items-center mb-2"
                                     v-on:drop="drop"
                                     v-on:dragover="allowDrop"
                                     :id="column.key">
                                    <div v-if="column.value" class="main-mapping-box-sm px-3 py-1 d-flex align-items-center mb-2"
                                         :id="'edit-' + column.key"
                                         :data-header="column.value">
                                        <div class="fw-600 text-sm m-0">{{ column.value }}</div>
                                    </div>
                                    <button type="button" v-show="column.value" :id="'button-' + column.key" class="custom-btn-round button-sm-danger" @click="(event) => removeMappedColumn(column, event)">
                                        <i class="la la-trash delete text-lg-center"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card-custom mb-4 bg-white">
                    <div class="card-header border-bottom-light  bg-white">
                        <h5 class="my-2 py-1  fw-600"> Data Fields List</h5>
                    </div>
                    <div class="card-body card-scroll">
                        <div v-for="(header, index) in headers" class="main-mapping-box-sm px-3 py-1 d-flex align-items-center mb-2"
                             v-on:drop="drop"
                             v-on:dragover="allowDrop"
                             v-on:dragstart="dragStart"
                             draggable="true"
                             :id="'dragColumn-' + index"
                             :data-header="header.name">
                            <div class="fw-600 text-sm m-0">
                                {{ header.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExternalImportTemplates',
    components: {
        //
    },
    props: [
        'value',
        'headers',
    ],
    data() {
        return {
            columns: this.value,
            localValue: {},
        }
    },
    computed: {
        //
    },
    watch: {
        localValue: {
            deep: true,
            handler() {
                this.$emit('change', this.localValue)
            }
        }
    },
    created() {
        this.$set(this, 'localValue', this.value ?? {})
    },
    methods: {
        /**
         * Drag start
         */
        dragStart (event) {
            event.dataTransfer.setData('Text', event.target.id);
        },

        /**
         * Allow drop
         */
        allowDrop (event) {
            event.preventDefault();
        },

        /**
         * Drop start
         */
        drop (event) {
            event.preventDefault();

            const id = event.dataTransfer.getData('Text');
            const value = document.getElementById(id).dataset.header;
            const columnKey = event.currentTarget.id;

            const index = this.columns.findIndex(c => c.key === columnKey);
            if (index !== -1) {
                this.$set(this.columns, index, {
                    ...this.columns[index],
                    value: value
                });
            }
        },

        /**
         * Remove mapped column
         */
        removeMappedColumn: function (mappedColumn, event) {
            event.preventDefault();

            const index = this.columns.findIndex(c => c.key === mappedColumn.key);
            if (index !== -1) {
                this.$set(this.columns, index, {
                    ...mappedColumn,
                    value: null
                });
            }
        },
    }
}
</script>

<style scoped lang="scss">
.card-custom,
.card-custom.custom-table{
    margin-bottom: 30px !important;
    border-radius: 0.3rem;
    position: relative;
    box-shadow: 0 0.46875rem 2.1875rem rgb(31 10 6 / 3%), 0 0.9375rem 1.40625rem rgb(31 10 6 / 3%), 0 0.25rem 0.53125rem rgb(31 10 6 / 5%), 0 0.125rem 0.1875rem rgb(31 10 6 / 3%);
}

.card-custom .card-header {
    padding: 1rem 1.5rem;
}

.card-custom .card-body {
    border-radius: 0.3rem;
    padding: 1.5rem 1.5rem;
}

.card-custom .dataTables_wrapper .top {
    position: absolute;
    bottom: 0;
    z-index: 2;
    font-size: 13px;
}

.main-mapping-box{
    border: 1px solid #e2e4e6;
    line-height: 1.1;
    height: 60px;
}

.main-mapping-box-sm{
    border: 1px solid #e2e4e6;
    line-height: 1.1;
    height: 50px;
    cursor: pointer;
}

.import-master-fields .main-mapping-box{
    justify-content: space-between !important;
}

.import-master-fields .main-mapping-box-sm{
    border: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
}

.import-master-fields .main-mapping-box-sm i{
    display:none !important;
}

.custom-btn-round {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    width: 38px;
    opacity: 1 !important;
    border: 0 !important;
    color: #ffffff;
    background: #cf1141;
    box-shadow: 0 3px 8.3px 0.7px rgba(0, 0, 0, 0.1);
    transition: all 0.2s;
    border-radius: 0.25rem;
    text-decoration: none !important;
    position: relative;
    z-index: 1;
}

.custom-btn-round:focus,
.custom-btn-round:active {
    box-shadow: 0 3px 8.3px 0.7px rgba(0, 0, 0, 0.1);
    border: 0 !important;
    outline: none !important;
}
</style>
